module.exports = __webpack_public_path__ + "static/media/property.24a720d1.svg";